<template>
  <main role="main">
    <section class="text-center">
      <div class="container ss">
        <div class="ss1" style="font-size:18px">
          <div style="float:left;width:110px;text-align: right;font-weight:bold">
            {{ ClassTitle }}
          </div>

          <div class="ss1b" style="width:calc(100% - 110px)">
            <span class="ss1a" style="margin-right:20px;" :class="selIndex==index?'ss1a_x':''"
                  v-for="(item, index) in classList" :key="index" @click="onSelCour(index)">
              {{ item.title }}
            </span>
          </div>
        </div>
        <div class="ss1 ss2" v-if="classList.length>0" style="font-size:16px;padding-left:130px;">
          <span class="ss1a" style="font-weight: normal;" :class="ClassID2==item.id?'ss1a_x':''"
                v-for="(item, index) in classList[selIndex].list" :key="index" @click="onSelClass(item.id)">
            {{ item.name }}
          </span>
        </div>
        <div class="ss1 ss3">
          <el-input v-model="Keywords" size="medium" :type="'text'" autocomplete="off" :maxlength="100"
                    prefix-icon="el-icon-search" placeholder="请输入关键字">
            <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
          </el-input>
        </div>
      </div>
    </section>

    <div class="album py-3 bg-light" style="padding-bottom:0 !important">
      <div class="container">
        <div class="row">
          <div class="col-md-3" v-for="(item, index) in CourseList" :key="index">
            <div class="card mb-3 shadow-sm kky">
              <el-image style="width: 100%;" :src="ossUrl+item.ImgUrl" fit="cover"  @click="onToHtml(item)" ></el-image>


              <div class="make" v-if="item.IsM>0">{{ item.daoqi > 0 ? '快到期' : '已购买' }}</div>
              <div class="make make1" v-if="item.IsM==0">未购买</div>
              <div class="cardTitle">{{ item.Name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  components: {},

  data() {
    return {
      ClassID2: this.$store.getters.getClassID2Value,
      url: "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      selIndex: this.$store.getters.getClassID1Value,
      classList: [],
      CourseList: [],
      ClassTitle: '',
      Keywords: '',
    };
  },

  watch: {
    $route() {
      this.onSelCour(this.$route.params.ID)
    },
  },

  mounted() {

    this.sApi('index', {token: this.$store.getters.getTokenValue}).then(res => {
      this.classList = res.ClassList;
      this.ClassTitle = res.ClassTitle;
      if (this.$route.params.ID) {
        this.onSelCour(this.$route.params.ID);
      } else {
        if (this.ClassID2 != -1) this.onSelClass(this.ClassID2)
        else this.onSelCour(0)
      }
    });
    setInterval(function () {
      var obj = document.getElementsByClassName('xl-chrome-ext-bar');
      if (obj.length > 0) {
        obj[0].remove();
      }
    }, 500)
  },

  created() {
  },

  methods: {
    onSelCour(ID) {
      this.$router.push({path: "/course/" + ID}).catch(data => {
      });
      ;
      console.log(ID)
      this.selIndex = ID
      console.log(this.selIndex)
      this.$store.commit('setClassID1Value', this.selIndex);
      this.ClassID2 = -1;
      this.$store.commit('setClassID2Value', -1);
      this.sApi("onSelClass", {
        ID: this.classList[this.selIndex].id,
        token: this.$store.getters.getTokenValue,
        Type: 1,
        Keywords: this.Keywords
      }).then(res => {
        this.CourseList = res;
      })
    },

    onSelClass(ID) {
      this.$store.commit('setClassID2Value', ID);
      this.ClassID2 = ID;
      this.sApi("onSelClass", {
        ID,
        token: this.$store.getters.getTokenValue,
        Type: 2,
        Keywords: this.Keywords
      }).then(res => {
        this.CourseList = res;
      })
    },
    onToHtml(item) {
      document.body.style = 'overflow:auto';
      if (this.$store.getters.getTokenValue) {
        if (item.IsM < 1) {
          this.$message({message: '课程未购买', type: 'warning'});
          return;
        }
        this.$router.push({path: "/showHtml/" + item.ID});
      } else {
        this.$parent.dialogVisible = true;
      }
    },
    onSearch() {
      if (this.ClassID2 == -1) {
        this.sApi("onSelClass", {
          ID: this.classList[this.$store.getters.getClassID1Value].id,
          token: this.$store.getters.getTokenValue,
          Type: 1,
          Keywords: this.Keywords
        }).then(res => {
          this.CourseList = res;
        })
      } else {
        this.sApi("onSelClass", {
          ID: this.$store.getters.getClassID2Value,
          token: this.$store.getters.getTokenValue,
          Type: 2,
          Keywords: this.Keywords
        }).then(res => {
          this.CourseList = res;
        })
      }
    }
  },
};
</script>

<style lang="scss">
.col-md-3 {
  padding-left: 7.5px;
  padding-right: 7.5px;
  position: relative;

  &:hover {
    transform: translateY(-10px);
    transition: all .3s;
  }
}

.cardTitle {
  width: 100%;
  padding: 0 10px;
  margin: 10px 0;
  font-size: 16px;
  color: #666;
  letter-spacing: 1.2px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.kky {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  border: 0;

  .make {
    position: absolute;
    left: 0;
    top: 0;
    width: 64px;
    line-height: 12px;
    background: linear-gradient(
            90deg,
            rgba(218, 156, 71, 1),
            rgba(250, 212, 156, 1)
    );
    border-radius: 4px 4px 160px 0px;
    color: #666;
    padding: 6px 6px 6px 0;
    text-align: center;
    font-weight: bold;
    font-size: 12px;
  }

  .make1 {
    background: #eee;
  }
}

.ss {
  display: inline-block;
  margin-top: 1rem;
  color: #666;
  font-size: 14px;
  margin-bottom: 0;
  padding-bottom: 0;

  .ss1 {
    width: 100%;
    float: left;
    border: 1px solid #eeeeee;
    background-color: #fff;
    padding: 10px 20px;
    text-align: left;
    line-height: 30px;

    .ss1a {
      display: inline-block;
      padding: 0 5px;
      margin: 5px;
      cursor: pointer;
      line-height: 21px;
      font-size: 18px;
      font-weight: bold;

      &:hover {
        color: #0d6efd;
      }
    }

    .ss1b {
      float: left;
    }
  }

  .ss2 {
    border-top: 0;
    min-height: 100px;
  }

  .ss3 {
    border-top: 0;
  }
}

.bd-placeholder-img {
  font-size: 1.125rem;
  text-anchor: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.image-slot {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
  font-size: 12px;
}

@media (min-width: 768px) {
  .bd-placeholder-img-lg {
    font-size: 3.5rem;
  }
}

.ss1a_x {
  color: #007bff;
}
</style>
